import React, { useState } from "react";
import CategorySlider from "../CategorySlider/CategorySlider";
import LandingPage from "../LandingPage/LandingPage";
import CollectionList from "../CollectionList/CollectionList";
import CarouselComponent from "../CarouselComponent/CarouselComponent";
import ModernCarousel from "../StackedCarousel/StackedCarousel";
import WaveDivider from "../../admin/Components/WaveDivider/WaveDivider";
import Snow from "../Snow/Snow";
export default function Home() {
  return (
    <>
      {/* <Snow /> */}

      <div className="mb-5 bg-transparent ">
        <CategorySlider></CategorySlider>
      </div>
      <div className="">
        <LandingPage></LandingPage>
      </div>
      <div className="mb-5">
        <CollectionList></CollectionList>
      </div>
      <div className="mb-5">
        <CarouselComponent></CarouselComponent>
      </div>
      <div className="mb-5">
        <ModernCarousel></ModernCarousel>
      </div>
    </>
  );
}
